import { Injectable } from '@angular/core';
import { OclLogbookTagService } from '../../../ocl/services/ocl-logbook-tag-service/ocl-logbook-tag.service';

@Injectable({
  providedIn: 'root',
})
export class OccLogbookTagService extends OclLogbookTagService {
  // tslint:disable:variable-name
  protected ParseLogBookTag = Parse.Object.extend('OCCLogBookTag');
  protected ParseLogBook = Parse.Object.extend('OCCLogBook');
  protected ParseTag = Parse.Object.extend('OCCTag');
  // tslint:enable
}
